import React from "react";

const LeadStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case "New":
        return {
          bgColor: "bg-blue-100 dark:bg-blue-900/20",
          textColor: "text-blue-600 dark:text-blue-400",
          label: "New"
        };
      case "Contacted":
        return {
          bgColor: "bg-purple-100 dark:bg-purple-900/20",
          textColor: "text-purple-600 dark:text-purple-400",
          label: "Contacted"
        };
      case "Qualified":
        return {
          bgColor: "bg-orange-100 dark:bg-orange-900/20",
          textColor: "text-orange-600 dark:text-orange-400",
          label: "Qualified"
        };
      case "Converted":
        return {
          bgColor: "bg-green-100 dark:bg-green-900/20",
          textColor: "text-green-600 dark:text-green-400",
          label: "Converted"
        };
      case "Lost":
        return {
          bgColor: "bg-red-100 dark:bg-red-900/20",
          textColor: "text-red-600 dark:text-red-400",
          label: "Lost"
        };
      default:
        return {
          bgColor: "bg-gray-100 dark:bg-gray-900/20",
          textColor: "text-gray-600 dark:text-gray-400",
          label: status
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor}`}>
      {config.label}
    </span>
  );
};

export default LeadStatusBadge;